<template>
  <div class="one_box">
      <div class="one_main">
          <div class="two_form_box">
            <el-form label-position="top" label-width="280px">
                <!-- 第一块 -->
                <div class="one_m_tit1">{{$t('main.text24')}}</div>
                <div class="one_m_tit2">{{$t('main.text82')}}</div>
                <template>
                    <div v-for="(item,index) in one_arr" :key="item.sjs">
                        <el-form-item :label="$t('main.text83')">
                            <div class="num_lift">
                                <el-input :disabled="input_dab" v-model="item.name"></el-input>
                                <span @click="item.is_show=!item.is_show">
                                    <i class="el-icon-arrow-up icon_up" v-if="item.is_show"></i>
                                    <i class="el-icon-arrow-down" v-else></i>
                                </span>
                            </div>
                        </el-form-item>

                        <template v-if="item.is_show">
                            <div>
                                <el-form-item :label="$t('main.text84')">
                                    <el-input :disabled="input_dab" v-model="item.identification_number"></el-input>
                                </el-form-item>
                                <el-form-item :label="$t('main.text85')">
                                    <el-input :disabled="input_dab" v-model="item.job_title"></el-input>
                                </el-form-item>

                                <el-form-item :label="$t('main.text86')">
                                  <div class="code_w">
                                    <div class="code_w3">
                                      <el-select filterable :disabled="input_dab" v-model="item.contact_number_code" :placeholder="$t('main.text200')">
                                        <el-option
                                          v-for="item in code_json"
                                          :key="item"
                                          :label="findKey(code_json, item)"
                                          :value="findKey(code_json, item)">
                                        </el-option>
                                      </el-select>
                                    </div>
                                    <div class="reg_code_box">
                                      <el-input class="code_w2" :disabled="input_dab" v-model="item.contact_number"></el-input>
                                    </div>
                                  </div>
                                </el-form-item>
                                

                                <!-- 上传 -->
                                <el-form-item>
                                    <div class="box_top_tit">{{$t('main.text87')}}</div>
                                    <el-upload
                                    :disabled="input_dab"
                                    class="upload-demo upload_box"
                                    drag
                                    :limit="10"
                                    action="#"
                                    ref="upload-file"
                                    :show-file-list="show_child"
                                    :file-list="set_item_url(item.url,item.index)"
                                    accept=".jpg,.jpeg,.png,.JPG,.JPEG,.pdf,.PDF"
                                    :http-request="ossUpload_assistant"
                                    :before-remove="function(file,fileList){child_beforeRemove(file,fileList,index)}"
                                    :data="{data_index:index}"
                                    multiple>
                                        <img class="load_icon" src="../../../assets/img/user_upload_img.png" alt="">
                                        <div class="el-upload__text upload_text">
                                        <div>{{$t('main.text88')}}</div>
                                        <div><el-button class="upload_btn">{{$t('main.text89')}}</el-button></div>
                                        <div>{{$t('main.text90')}}</div>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                            </div>
                        </template>
                    </div>
                </template>

                <el-form-item>
                    <div><el-button :disabled="input_dab" class="add_yellow_btn" @click="add_one_arr">{{$t('main.text91')}}</el-button></div>
                    <div class="add_btm_text">{{$t('main.text92')}}</div>
                </el-form-item>

                <!-- 第二块 -->
                <div class="select_box">
                  <!-- <div class="select_box_top" @click="text_is_show=!text_is_show"> -->
                  <div class="select_box_top">
                    {{$t('main.text93')}}
                    <!-- <span>
                      <i class="el-icon-arrow-down" v-if="text_is_show"></i>
                      <i class="el-icon-arrow-up icon_up" v-else></i>
                    </span> -->
                  </div>
                  <div class="select_box_body" v-if="text_is_show">
                    <div class="select_info1">
                      {{$t('main.text94')}}
                    </div>
                    <div class="select_info2">
                      {{$t('main.text95')}}
                    </div>
                  </div>
                </div>

                <div class="one_m_tit1 two_top">{{$t('main.text96')}}</div>
                  <el-form-item :label="$t('main.text97')">
                    <div class="num_lift">
                      <el-input :disabled="input_dab" v-model="two_arr.name"></el-input>
                    </div>
                  </el-form-item>

                  <el-form-item :label="$t('main.text98')">
                      <el-input :disabled="input_dab" v-model="two_arr.designation"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <span slot="label">{{$t('main.text99')}} 
                      <el-popover
                        width="190"
                        placement="right"
                        popper-class="info_pop_bgc"
                        trigger="hover">
                        <i slot="reference" class="el-icon-question info_icon"></i>
                        <div class="info_text">{{$t('main.text100')}}</div>
                      </el-popover>
                    </span>
                    <!-- 日期选择 -->
                    <!-- <el-input :disabled="input_dab" v-model="two_arr.date" :placeholder="$t('main.text101')"></el-input> -->
                    <!-- :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' " -->
                    <!-- format="dd-MM-yyyy" -->
                    <el-date-picker
                      class="time_box"
                      :editable="false"
                      :popper-class="lan=='en'?'zdy_picker_en':'' "
                      :disabled="input_dab"
                      v-model="two_arr.date"
                      type="date"
                      :format="v_lan=='en'?'dd/MM/yyyy':'yyyy/MM/dd' "
                      value-format="dd-MM-yyyy"
                      :placeholder="$t('main.text242')">
                    </el-date-picker>

                  </el-form-item>
                  <el-form-item>
                      <span slot="label">{{$t('main.text102')}} 
                       <el-popover
                          width="220"
                          placement="right"
                          popper-class="info_pop_bgc"
                          trigger="hover">
                          <i slot="reference" class="el-icon-question info_icon"></i>
                          <div class="info_text">{{$t('main.text103')}}</div>
                        </el-popover> 
                      </span>
                      <div class="signature_box" @click="signature_dlg_fun">
                        <img v-if="two_arr.signature" class="signature_box_img" :src="two_arr.signature" alt="">
                      </div>
                  </el-form-item>
              
              <el-form-item>
                <el-button :disabled="input_dab" class="Submit_btn" @click="upload_all_data">{{$t('main.text104')}}</el-button>
              </el-form-item>
            </el-form>
          </div>
      </div>

      <!-- 签名 -->
      <!-- :destroy-on-close="true" -->
      <el-dialog
        :title="$t('main.text105')"
        :visible.sync="signature_dlg"
        custom-class="dlg"
        append-to-body
        
        width="700px">
        <div class="esign_box">
          <vue-esign ref="esign" :width="700" :height="350" :isCrop="isCrop" :lineWidth="lineWidth" :lineColor="lineColor" :bgColor.sync="bgColor" />
          <img :src="resultImg" alt="">
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel_btn" @click="signature_dlg=false">{{$t('main.text7')}}</el-button>
            <el-button class="cancel_btn" @click="handleReset">{{$t('main.text71')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="handleGenerate">{{$t('main.text104')}}</el-button>
        </span>
      </el-dialog>

  </div>
</template>

<script>
import {awsS3Auth,getKycInfo,kyc_trading} from '@/api/api';
// import {awsS3Auth,getKycInfo} from '@/api/api';
import AWS from 'aws-sdk';
export default {
    data() {
        return {
          lan:localStorage.getItem("language"),
          awsS3_data:'',
          show_child:true,
          code_json:'',
          one_arr:[
              {
                sjs:this.createCode(),
                is_show:true,
                name:'',
                identification_number:'',
                job_title:'',
                contact_number:'',
                contact_number_code:'',
                url:[],
                uid:[]
              },
          ],
          two_arr:{
            name:'',
            designation:'',
            date:'',
            signature:'',
          },
          text_is_show:true,
          signature_dlg:false,

          one_data_all:false,//是否全部填写数据
          two_data_all:false,//是否全部填写数据

          // 签名配置
          lineWidth: 4,
          lineColor: '#fff',
          bgColor: '',
          resultImg: '',
          // isCrop  Boolean false   是否裁剪，在画布设定尺寸基础上裁掉四周空白部分
          isCrop: false,
          // --over--
          input_dab:false,

          api_old_data1:'',//老数据
          api_old_data2:'',//老数据

            
            
        }
    },
    mounted() {
      this.S3Auth();
      this.get_kyc();
      this.bus.$on('router_4_child',(v)=>{
        if(v==4){
          // 重新触发 保存操作
          this.upload_all_data();
        }
      })
    },
    created() {
      if(this.v_lan=='ch'){
        this.code_json=require("@/assets/phone_code/num_area_ch.json");
      }else{
        this.code_json=require("@/assets/phone_code/num_area_en.json");
      }
    },
    destroyed(){
      this.bus.$off('router_4_child')
    },
    watch:{
        one_arr:{ //监听的对象
            deep:true, //深度监听设置为 true
            handler:function(newV,oldV){
                newV;oldV;
                this.old_data_new_data();
            }
        },
        two_arr:{ //监听的对象
            deep:true, //深度监听设置为 true
            handler:function(newV,oldV){
                newV;oldV;
                this.old_data_new_data();
            }
        }
        
    },
    methods: {
      // 随机数
      createCode() {
          var code = "";
          var codeLength = 10;
          var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);
          for (var i = 0; i < codeLength; i++) {
              var index = Math.floor(Math.random() * 9);
              code += random[index];
          }
          return code;
      },
      //创建一个方法，返回value值对应的key
      findKey(obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find((k) => compare(obj[k], value));
      },
      set_item_url(item_url,index){
        // https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/3.jpg
        let url=[];
        index;
        // console.log(index,item_url);

        // let text1='https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/autonym/3.jpg';
        // let text2 = text1.split("/");
        // console.log(text1);
        // console.log(text2[4]);

        for (let i = 0; i < item_url.length; i++) {
            let text1=item_url[i];
            let text2=[];
            text2=text1.split("/");
            url.push({name:text2[5],url:text1})
        }
        return url;
      },
      async S3Auth() {
        const res = await awsS3Auth();
        if (res.data.code == 200) {
            this.awsS3_data = res.data.data;
            // console.log(this.awsS3_data);
            //参数
            AWS.config.update({
            region: "ap-southeast-1",
            credentials: new AWS.CognitoIdentityCredentials({
              IdentityPoolId: this.awsS3_data.IdentityPoolId,
              IdentityId: this.awsS3_data.IdentityId,
              Logins: {
              "cognito-identity.amazonaws.com": this.awsS3_data.Token,
              },
            }),
          });
        }else{
          // this.$message.closeAll();
          // this.$message.error(res.data.msg);
          this.message.ismessage('error',res.data.msg);
        }
      },
      get_kyc(){
        getKycInfo().then(res=>{
          if (res.data.code==200) {
            // console.log(res.data.data);
            if(res.data.data.trading_form&&res.data.data.trading_form!=''){
              // this.one_arr=JSON.parse(res.data.data.trading_form);
              let data1=JSON.parse(res.data.data.trading_form);
              // console.log(JSON.parse(res.data.data.trading_form));
              if(!data1[0].contact_number){
                data1[0].contact_number=localStorage.getItem('feb_phone_num');
              }
              if(!data1[0].contact_number_code){
                data1[0].contact_number_code=localStorage.getItem('feb_phone_cc');
              }
              this.one_arr=data1;
              this.api_old_data1=JSON.parse(JSON.stringify(data1));//老数据
            }else{
              let data2 =this.one_arr;
              if(!data2[0].contact_number){
                data2[0].contact_number=localStorage.getItem('feb_phone_num');
              }
              if(!data2[0].contact_number_code){
                data2[0].contact_number_code=localStorage.getItem('feb_phone_cc');
              }
              this.one_arr=data2;
              this.api_old_data1=JSON.parse(JSON.stringify(data2));//老数据
            }

            if(res.data.data.trading_director&&res.data.data.trading_director!=''){
              let data2=JSON.parse(res.data.data.trading_director)[0];
              this.two_arr=data2;
              this.api_old_data2=JSON.parse(JSON.stringify(data2));//老数据
            }else{
              this.api_old_data2=JSON.parse(JSON.stringify(this.two_arr));//老数据
            }

            // status 2 待审核   3审核中  4审核通过  5审核失败
            if(
              res.data.data.status==2||
              res.data.data.status==3||
              res.data.data.status==4||
              res.data.data.status==5
              ){
                this.input_dab=true;
            }else{
              this.input_dab=false;
            }

            // this.old_data_new_data();

          }else{
            // this.$message.closeAll();
            // this.$message.error(res.data.msg);
            this.message.ismessage('error',res.data.msg);
          }
        })
      },
      add_one_arr(){
        if(this.one_arr.length<3){
          this.one_arr.push({
              sjs:this.createCode(),
              is_show:true,
              name:'',
              identification_number:'',
              job_title:'',
              contact_number:'',
              contact_number_code:'',
              url:[],
              uid:[]
              })
        }else{
          // this.$message.closeAll();
          // this.$message.error('Add up to 3');
          this.message.ismessage('error',this.$t('main.text106'));
        }
      },
      ossUpload_assistant(data){
        data;
        this.$store.state.aws_loading = true;
        this.show_child=false;
        let file_type = data.file.type.split("/")[1];
        const uploadPath =  'autonym/'+this.createCode()+'/'+this.random_16+'.'+file_type;
        let s3 = new AWS.S3();
        let params = {
            Body: data.file,
            Bucket: "data-storage-d3",
            Key: uploadPath,
            ACL: "public-read",
        };
        s3.putObject(params,(err)=>{
          if(err){
            // console.error('error');
            // console.log(err);
            // console.log(err, err.stack);
            // alert(err, err.stack);
            this.$store.state.aws_loading=false;
            return this.message.ismessage('error',this.$t('bank_card.Upload_error'));
          }else{
            const url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
            this.one_arr[data.data.data_index].url.push(url);
            this.one_arr[data.data.data_index].uid.push(data.file.uid);
            this.$store.state.aws_loading=false;
            this.show_child=true;
          }
        })
      },
      child_beforeRemove(file,fileList,index){
        file;fileList;index;
        for (let j = 0; j < this.one_arr[index].url.length; j++) {
          if(this.one_arr[index].url[j].indexOf(file.url)!=-1){
            this.child_index_j=j;
            break;
          }
        }
        this.one_arr[index].url.splice(this.child_index_j,1);
        this.one_arr[index].uid.splice(this.child_index_j,1);
      },
      upload_all_data(){

        //此方法内的this指向
        var that = this;
        // let flag = that.corporate_fi.every(item => !!item.score)
        let flag = that.one_arr.every(item =>{
            return item.name==''&&item.identification_number==''&&item.job_title==''&&item.contact_number==''&&item.url.length<=0&&item.uid.length<=0
        })
        // two_arr:{
        //   name:'',
        //   designation:'',
        //   date:'',
        //   signature:'',
        // },

        let flag2=null;
        
        if(
          this.two_arr.name==""&&
          this.two_arr.designation==""&&
          this.two_arr.date==""&&
          this.two_arr.signature==""
        ){
          flag2=true;
        }else{
          flag2=false;
        }

        // if (flag&&flag2) {
        if (flag&&flag2) {
          // this.$message.closeAll();
          // this.$message.error('Data cannot be empty');
          this.message.ismessage('error',this.$t('main.text107'));
          this.$store.state.login.data_no_router=false;
          return false;
        }
        // console.log(flag2);

        for (let i = 0; i < this.one_arr.length; i++) {
          if(
            this.one_arr[i].name&&
            this.one_arr[i].identification_number&&
            this.one_arr[i].job_title&&
            this.one_arr[i].contact_number&&
            this.one_arr[i].url.length>0&&
            this.one_arr[i].uid.length>0
          ){
            this.one_data_all=true;
            break;
          }
        }
        // console.log(this.one_arr);
        // console.log(this.one_data_all);


        if (this.two_arr.name&&this.two_arr.designation&&this.two_arr.date&&this.two_arr.signature) {
          this.two_data_all=true;
        }
        
        // console.log(this.two_arr);
        // console.log(this.two_data_all);

        // shareholder_status	Number	0信息不完整 1信息完整
        // trading_form	Arr	
        // trading_director	Arr

        kyc_trading({
          trading_status:(this.one_data_all&&this.two_data_all)?1:0,
          trading_form:this.one_arr,
          trading_director:[this.two_arr]
        }).then(res=>{
          // console.log(res);
          if(res.data.code==200){
            // this.$message.closeAll();
            // this.$message.success('Saved successfully');
            this.message.ismessage('success',this.$t('main.text108'));
            this.get_kyc();
            // this.bus.$emit('kyc_step_load');
            setTimeout(() => {
              this.bus.$emit('info_4_all');
            }, 100);
          }else{
            // this.$message.closeAll();
            // this.$message.error(res.data.msg);
            this.message.ismessage('error',res.data.msg);
            this.$store.state.login.data_no_router=false;
          }
        })



      },
      // 把签名的base64图片放到aws生成地址
      signature_aws_addr(data){
        data;
        this.$store.state.aws_loading = true;
        const uploadPath =  'autonym/'+this.createCode()+data.name;
        let s3 = new AWS.S3();
        let params = {
            Body: data,
            Bucket: "data-storage-d3",
            Key: uploadPath,
            ACL: "public-read",
        };
        let url;
        s3.putObject(params,(err)=>{
          err;
          if(err){
            // console.error('error');
            // console.log(err);
            // console.log(err, err.stack);
            alert(err, err.stack);
            this.$store.state.aws_loading=false;
          }else{
            url ="https://data-storage-d3.s3.ap-southeast-1.amazonaws.com/" +uploadPath;
            this.$store.state.aws_loading=false;
            // console.log(url);
            if(url){
              this.two_arr.signature=url;
            }
          }
          
        })
      },
      signature_dlg_fun(){
        if(this.input_dab==false){
          this.signature_dlg=true;
        }
      },
      // 签名重置
      handleReset () {
        this.$refs.esign.reset();
      },
      // 签名完成
      async handleGenerate () {
        try {
          let res=await this.$refs.esign.generate();
          this.signature_aws_addr(this.base64ImgtoFile(res));
          this.signature_dlg=false;
        } catch (error) {
          if(error){
            // console.log('error');
            // this.$message.closeAll();
            // this.$message.error('Please sign before submitting');
            this.message.ismessage('error',this.$t('main.text109'));
          }
        }
      },
      base64ImgtoFile(dataurl, filename = 'signature') {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let suffix = mime.split('/')[1]
        let bstr = atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime
        })
      },
      old_data_new_data(){
        if(this.api_old_data1&&this.one_arr&&this.api_old_data2&&this.two_arr){
          let data_true=((JSON.stringify(this.api_old_data1) == JSON.stringify(this.one_arr)&&(JSON.stringify(this.api_old_data2) == JSON.stringify(this.two_arr))));
          // console.log(data_true);
          this.$store.state.login.router_true=data_true;
        }else if((this.api_old_data1==''&&this.one_arr)||(this.api_old_data2==''&&this.two_arr)){
          // console.log(2);
        }

      },

    },
}
</script>

<style scoped>
.one_box{
    flex: 1;
    background: #04182A;
    border-radius: 16px;
    box-sizing: border-box;
    padding: 60px 0;
}
.one_main{
    width: 420px;
    margin: auto;
}
.one_m_tit1{
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    margin-bottom: 8px;
}
.one_m_tit2{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 40px;
}
.one_m_tit3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    opacity: 0.8;
    margin-bottom: 8px;
}
.one_m_tit4 .el-radio__label{
    font-size: 15px;
}
.one_m_tit4 >>> .el-radio{
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner {
    border: 1px solid #fff;
    background-color: transparent;
}
.one_m_tit4 >>> .el-radio__input.is-checked .el-radio__inner {
    border-color: #fff;
    background: transparent;
}
.one_m_tit4 >>> .el-radio__inner::after {
    width: 7px;
    height: 7px;
    background-color: #fff;
}
.one_m_tit4 >>> .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
}
.one_m_tit4 >>> .el-radio__inner:hover {
    border-color: #fff;
}
.add_yellow_btn,
.add_yellow_btn:hover{
    width: 214px;
    height: 46px;
    background: #04182A;
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    margin: auto;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    text-align: center;
    color: #DEB981;
    border-color: #DEB981;
    display: block;
    margin-top: 20px;
    margin-bottom: 12px;
}
.add_btm_text{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
}
.two_top{
    margin-top: 20px;
}



/* --上传-- */
.upload_header{
    height: 104px;
    background: #041728;
    display: flex;
    position: relative;
}
.upload_t_logo{
    width: 230px;
    margin: auto;
}
.upload_t_btn{
  border: 1.5px solid #F1C787;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 8px 20px;
  cursor: pointer;
  margin-left: 10px;
  color: #F1C787;
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translate(0,-50%);
}
.form_box{
    max-width: 420px;
    margin: auto;
    margin-top: 40px;
}
.form_tit{
    font-weight: bold;
    font-size: 22px;
    line-height: 26px;
    color: #314869;
    margin-top: 60px;
}
.upload_box >>> .el-upload{
    width: 100%;
}
.upload_box >>> .el-upload-dragger{
    background: rgba(222, 185, 129, 0.04);
    border: 1.5px dashed #DEB981;
    border-radius: 4px;
    width: 100%;
    height: 190px;
}
.icon_upload{
    margin: 10px auto 0;
    font-size: 50px;
}
.upload_text div{
    line-height: initial;
    color: rgba(255, 255, 255, 0.6);
}
.upload_btn{
    border-color: #F1C788;
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 18px; */
    color: #04182A;
    margin: 12px auto;
    height: 38px;
}
.box_top_tit{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    opacity: 0.6;
    margin-bottom: 12px;
}
.el-form-item {
    margin-bottom: 15px;
}
.add_btn{
    width: 214px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    color: #DEB981;
    border: 1px solid #DEB981;
    cursor: pointer;
    margin: 30px auto;
    box-shadow: 0px 2px 4px rgb(222 185 129 / 20%);
}
.Submit_btn,
.Submit_btn:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    border-color: #F1C788;
    width: 100%;
    color: #04182A;
    margin-bottom: 30px;
    margin-top: 20px;
}
.load_icon{
    width: 30px;
    vertical-align: middle;
    margin-top: 25px;
    margin-bottom: 10px;
}
.upload_body >>> .el-upload-list__item .el-icon-close-tip{
    display: none !important;
    color: transparent;
}
/* --over-- */

/* --form-- */
.two_form_box >>> .el-form--label-top .el-form-item__label{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.two_form_box >>> .el-input__inner{
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  color: #fff;
}
.two_form_box .el-select {
  width: 100%;
}
.num_lift{
  position: relative;
  margin-bottom: 8px;
}
/* .el-form-item .num_lift:last-child{
  margin-bottom: 0;
} */
.num_lift span{
  position: absolute;
  right: -30px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
/* .num_lift >>> .el-input__inner{
  text-indent: 1em;
} */
/* --over-- */

/* 444 */
.select_box{
  width: 420px;
  background: #041E35;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 20px;
}
.select_box_top{
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 22px;
  position: relative;
  /* cursor: pointer; */
}
.select_box_top span{
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
}
.select_box_body{
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
}
.select_info1{
  border-top: 1px solid #687886;
  margin-bottom: 20px;
  padding-top: 10px;
  margin-top: 10px;
}
.info_icon{
  cursor: pointer;
}
.info_text{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.6;
  word-wrap: break-word;
  word-break: break-word;
}
.signature_box{
  height: 100px;
  background: #223C58;
  border: 1.5px solid rgba(49, 72, 105, 0.1);
  border-radius: 4px;
  cursor: pointer;
}
.esign_box{
  background: #F1C788;
}
.signature_box_img{
  height: 100%;
  max-width: 100%;
  display: block;
  margin: auto;
}


/* --over-- */

/* ---dlg--- */
.dlg_body{
    background: #041E35;
    color: #fff;  
}
.d_body{
    box-sizing: border-box;
    padding: 40px 0;
    max-width: 420px;
    margin: auto;
}
.dlg_u_box{
    display: flex;
    align-items: center;
}
.dlg_u1{
    width: 100px;
    height: 100px;
    border: 2px solid #DEB981;
    border-radius: 50%;
}
.dlg_u2,.dlg_u2:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #04182A;
    margin-left: 40px;
    margin-bottom: 8px;
}
.dlg_u3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    margin-left: 40px;
}
.dlg_form{
    margin-top: 25px;
}
.dlg_form >>> .el-form-item__label{
    line-height: 30px;
    color: #fff;
    padding: 0;
}
.cancel_btn{
    color: #F1C788;
    border-color: #F1C788;
    background: transparent;
}
.confirm_btn{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border-radius: 4px;
    color: #04182A;
    border-color: #F1C788;
    margin-left: 20px;
}
/* --- */
/* 滚动条 */
.one_box {
  overflow: auto;
  height: calc(100vh - 120px);
}
.one_box::-webkit-scrollbar {
  width: 5px;
}
.one_box::-webkit-scrollbar-thumb {
  border-radius: 5px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #F1C788;
}
/* --over-- */

.one_box >>> .el-upload-list{
  height: 100px;
  /* background: pink; */
  overflow: auto;
}
/* 滚动条 */
.one_box >>> .el-upload-list {
  overflow: auto;
}
.one_box >>> .el-upload-list::-webkit-scrollbar {
  width: 5px;
}
.one_box >>> .el-upload-list::-webkit-scrollbar-thumb {
  border-radius: 7px;
  /* -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
  background: #F1C788;
}
/* --over-- */

/* 手机国家码 */
.code_w{
  display: flex;
}
.code_w2{
  /* width: 68%; */
}
.code_w3{
  margin-right: 16px;
  /* flex: 1; */
}
.code_w3 span{
  background: #000;
}
.reg_code_box{
  position: relative;
  width: 80%;
}
/* over */
.time_box{
  width: 100%;
}

</style>
<style>
.info_pop_bgc{
  background: #03101C;
  box-shadow: 0px 4px 8px rgba(3, 13, 22, 0.2);
  border-radius: 12px;
  border: none;
}
.info_pop_bgc .popper__arrow{
  display: none;
}
.el-upload-list__item {
    transition: none !important;
}
.icon_up:before {
    content: "\e6e1" !important;
}
</style>

<style scoped>
@media screen and (max-width: 850px) {
    .one_main {
        margin: inherit;
        width: 90%;
    }
    .select_box {
      width: 100%;
    }


}
</style>